// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uXAt","colMin":"styles_colMin__2pTcE"};